<template>
    <modal-content @close="$emit('close')">
        <p>Váš přístupový kód je</p>
        <div class="info-label"><strong>{{bearer}}</strong></div>
        <p class="text--maroon">Z bezpečnostních důvodů vám jej již znovu nezobrazíme.</p>
    </modal-content>
</template>

<script>
import ModalContent from 'domovio-core/src/components/Modal/ModalContent';

export default {
    props:      {
        bearer: {
            type:     String,
            required: true,
        }
    },
    components: { ModalContent },
}
</script>
